// Copyright (c) 2025 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { Box, Container, Paper, Skeleton, Stack } from '@mui/material';

/**
 * Skeleton loading state for the return order details page.
 */
export function ReturnOrderDetailsSkeleton() {
  return (
    <Container maxWidth="lg" sx={{ py: 3 }}>
      <Stack spacing={3}>
        {/* Header skeleton */}
        <Stack spacing={1}>
          <Skeleton variant="text" width={200} height={20} />
          <Skeleton variant="text" width={300} height={40} />
        </Stack>

        {/* Main content skeleton */}
        <Paper variant="outlined" sx={{ p: 3 }}>
          <Stack spacing={2}>
            <Skeleton variant="text" width="60%" height={24} />
            <Skeleton variant="text" width="40%" height={24} />
            <Skeleton variant="text" width="50%" height={24} />
            <Box sx={{ pt: 2 }}>
              <Skeleton variant="rectangular" height={200} />
            </Box>
          </Stack>
        </Paper>
      </Stack>
    </Container>
  );
}
